import React, { useState } from 'react';
import { Box, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { formatImageSize } from '../../utils/imageValues';

const kind = (mime) => (mime || 'image').replace(/^image\//, '').toUpperCase();

/**
 * A small preview of an embedded image (see utils/imageValues.detectImage) that
 * opens full size in a dialog when clicked.
 */
const ImageThumbnail = ({ image, maxHeight = 160, alt = 'Embedded image' }) => {
  const [open, setOpen] = useState(false);
  const [dims, setDims] = useState(null);
  const caption = `${kind(image.mime)} image${dims ? `, ${dims.w} × ${dims.h}` : ''}, ${formatImageSize(image.bytes)}`;
  return (
    <>
      <Box component="button" type="button" onClick={() => setOpen(true)}
        aria-label={`Open ${caption} full size`} title="Click to open full size"
        sx={{
          all: 'unset', cursor: 'zoom-in', display: 'block', mt: 0.5, lineHeight: 0,
          borderRadius: 0.5, border: 1, borderColor: 'divider', bgcolor: 'common.white',
          maxWidth: '100%', width: 'fit-content',
          '&:focus-visible': { outline: '2px solid', outlineColor: 'primary.main', outlineOffset: 2 },
        }}>
        <Box component="img" src={image.src} alt={alt}
          onLoad={(e) => setDims({ w: e.currentTarget.naturalWidth, h: e.currentTarget.naturalHeight })}
          sx={{ display: 'block', maxHeight, maxWidth: '100%', borderRadius: 0.5 }} />
      </Box>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xl"
        aria-labelledby="image-thumbnail-title">
        <DialogTitle id="image-thumbnail-title" sx={{ pr: 6 }}>
          {caption}
          <IconButton aria-label="Close" onClick={() => setOpen(false)}
            sx={{ position: 'absolute', right: 8, top: 8 }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 1, bgcolor: 'common.white', textAlign: 'center' }}>
          <Box component="img" src={image.src} alt={alt}
            sx={{ display: 'block', mx: 'auto', maxWidth: '100%', maxHeight: '80vh' }} />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ImageThumbnail;
